import { render, staticRenderFns } from "./AutofonTab.vue?vue&type=template&id=add9d7ea&scoped=true"
import script from "./AutofonTab.vue?vue&type=script&lang=js"
export * from "./AutofonTab.vue?vue&type=script&lang=js"
import style0 from "./AutofonTab.vue?vue&type=style&index=0&id=add9d7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add9d7ea",
  null
  
)

export default component.exports